import script from "./CreateNewAccountFrame.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateNewAccountFrame.vue?vue&type=script&setup=true&lang=ts"

import "./CreateNewAccountFrame.vue?vue&type=style&index=0&id=0529ed28&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0529ed28"]])

export default __exports__